<template>
	<div>
		<v-toolbar color="blue" dark>
			<v-toolbar-title class="text-xs-center; width=200px;">
				<v-icon color="white">people</v-icon>
				<b style="font-size: 16px"> Projekt wspólny</b>
			</v-toolbar-title>
			<v-layout>
				<v-flex pl-5>
					<v-switch v-if="!readonly" v-model="localMutualProject" color="white" hide-details
						@change="switchChange" aria-label="label for switch"/>
				</v-flex>
			</v-layout>
		</v-toolbar>

		<v-expand-transition>
			<v-layout v-show="mutualProject">
				<v-flex xs12 sm6 d-flex pa-3>
					<v-autocomplete
						v-if="!readonly"
						v-model="selectedBidders"
						:items="availableBidders"
						multiple
						item-text="polishName"
						item-value="id"
						:label="readonly ? 'Współoferenci' : 'Oferenci, z którymi realizujesz projekt'"
						aria-label="bidders"
						for="project-other-bidders-bidders-with"
						id="project-other-bidders-bidders-with"
						@input="registerBiddersChanged"
						return
						object
					></v-autocomplete>
					<div v-if="readonly">
						<b class="mr-2">Współoferenci: </b> {{selectedBiddersReadOnlyNames.join(", ")}}
					</div>
				</v-flex>
			</v-layout>
		</v-expand-transition>
		<egranty-validation-error
			:error="error"
		></egranty-validation-error>
	</div>
</template>

<script>
  import {Project} from "@/api/generated/Project";
  import EgrantyValidationError from "@/genericComponents/EgrantyValidationError";
  import {Bidder} from "@/api/generated/Bidder";

  export default {
    name: "ProjectOtherBidders",

    components: {EgrantyValidationError},

    data() {
      return {
        availableBidders: [],
        selectedBidders: [],
        selectedBiddersReadOnlyNames: [],
        localMutualProject: this.mutualProject,
        error: "",
      };
    },

    methods: {
      validate() {
        if (this.mutualProject && this.selectedBidders.length === 0) {
          this.error = "Jeżeli jest to projekt wspólny, to muszą być wybrani współoferenci";
          return false;
        }
        return true;
      },

      switchChange () {
        this.error = "";
        this.selectedBidders = [];
        this.emitBiddersChanged();
      },

      registerBiddersChanged(val) {
        this.$emit("input", val);
        this.emitBiddersChanged();
      },

      emitBiddersChanged () {
        this.$emit("biddersChanged");
      },

      loadReadOnlyMutualBiddersNames() {
        if (this.$route.params.version) {
          this.selectedBidders.forEach(bidderId => {
            Bidder.getOriginalProjectVersionDetails(this, bidderId, this.$route.params.projectId, this.$route.params.version, successResponse => {
              this.selectedBiddersReadOnlyNames.push(successResponse.polishName);
            }, errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się załadować danych oferenta", errorResponse);
            });
          });
        } else {
          this.selectedBidders.forEach(bidderId => {
            Bidder.getOriginalProjectDetails(this, bidderId, this.$route.params.projectId, successResponse => {
              this.selectedBiddersReadOnlyNames.push(successResponse.polishName);
            }, errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się załadować danych oferenta", errorResponse);
            });
          });
        }
      },

      loadAvailableMutualBidders() {
        Project.getAvailableProjectMutualBidders(this, this.$route.params.projectId, successResponse => {
              this.availableBidders = successResponse;
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się pobrać listy współoferentów", errorResponse);
            }
        );
      }
    },

    mounted() {
      if (this.readonly) {
        this.loadReadOnlyMutualBiddersNames();
      } else {
        this.loadAvailableMutualBidders();
      }
    },

    props: {
      value: {
        type: Array, required: true,
      },
      readonly: {
        type: Boolean, required: true
      },
      mutualProject: {
        type: Boolean, required: true
      }
    },

    watch: {
      value: {
        immediate: true,
        handler (val) {
          this.selectedBidders = val;
        },
      },

      localMutualProject: {
        handler (val) {
          this.$emit("change", val);
        },
      },
    },
  };
</script>

<style scoped>
  >>> .v-toolbar__content {
    padding: 0 8px;
  }
</style>